module.exports = __webpack_public_path__ + "img/ic-bell-notification.21492bb9.svg";